<template>
  <vx-card title="Umsatz: Wochentag × Uhrzeit">
    <vue-apex-charts
      type="heatmap"
      height="320"
      :options="chartOptions"
      :series="series"
    />
  </vx-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

const DAY_LABELS = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
// MongoDB $dayOfWeek: 1=Sunday ... 7=Saturday
const DAY_ORDER = [2, 3, 4, 5, 6, 7, 1];

export default {
  name: "AnalyticsWeekdayHeatmap",
  components: { VueApexCharts },
  computed: {
    rawData() {
      return this.$store.state.analytics.weekdayHeatmap || [];
    },
    hours() {
      const set = new Set(this.rawData.map((d) => d._id.hour));
      return Array.from(set).sort((a, b) => a - b);
    },
    series() {
      return DAY_ORDER.slice()
        .reverse()
        .map((dow) => {
          const dayLabel = DAY_LABELS[dow - 1];
          return {
            name: dayLabel,
            data: this.hours.map((hour) => {
              const entry = this.rawData.find(
                (d) => d._id.dayOfWeek === dow && d._id.hour === hour
              );
              return {
                x: `${hour}:00`,
                y: entry ? Math.round(entry.revenue) : 0,
              };
            }),
          };
        });
    },
    chartOptions() {
      return {
        chart: {
          toolbar: { show: false },
          foreColor: "#c2c6dc",
          background: "transparent",
        },
        theme: { mode: "dark" },
        dataLabels: { enabled: false },
        colors: ["#C41E2A"],
        plotOptions: {
          heatmap: {
            radius: 4,
            shadeIntensity: 0.7,
            colorScale: {
              inverse: false,
              min: 0,
            },
          },
        },
        tooltip: {
          y: {
            formatter: (val) => val.toLocaleString("de-DE") + " €",
          },
        },
        xaxis: {
          labels: { style: { fontSize: "11px" } },
        },
      };
    },
  },
};
</script>
